export const VERSION_CONTROL_SERVICE_ENDPOINT = window.env.VUE_APP_VERSION_CONTROL_SERVICE_URL;

// Resource paths
export const VERSION_CONTROL_MODULE_RESOURCE_PATH = '/module';
export const MODULE_TAG_RESOURCE_PATH = '/tag';
export const VERSION_CONTROL_NODE_RESOURCE_PATH = '/module';
